/* eslint-disable */
const type = {
  base: 'Avenir-Book',
  bold: 'Avenir-Black',
  emphasis: 'HelveticaNeue-Italic'
}

const size = {
  h1: 38,
  h2: 34,
  h3: 30,
  h4: 26,
  h5: 20,
  h6: 19,
  input: 18, // 18,
  regular: 17,
  medium: 14,
  small: 12,
  tiny: 8.5
}

// patch for react-native-web until we can figure out the font situation
// use sans-serif all thru out so we dont get Times Roman 
const font = {

  boldLogin: 'sans-serif', // 'Gilroy-Bold',
  extraBoldLogin: 'sans-serif', //'Gilroy-ExtraBold',
  italicBoldLogin: 'sans-serif', //`Gilroy-BoldItalic`,
  lightLogin: 'sans-serif', // 'Gilroy-Light',
  regularLogin: 'sans-serif', // 'Gilroy-Regular',
  semiBoldLogin: 'sans-serif', // `Gilroy-SemiBold`,
  thinLogin: 'sans-serif', // `Gilroy-Thin`,

/*
  bold: 'Futura-Medium',
  bold: 'Futura-CondensedExtraBold',
  extraBold: 'Futura-CondensedExtraBold',
  italicBold : `Futura-MediumItalic`,
  light: 'Futura',
  regular: 'Futura',
  semiBold : `Futura-Medium`,
  thin : `Futura`,

// find where we are using default fonts...
  bold       : 'Zapfino',
  extraBold  : 'Zapfino',
  italicBold : `Zapfino`,
  light      : 'Zapfino',
  regular    : 'Zapfino',
  semiBold   : `Zapfino`,
  thin       : `Zapfino`,
*/  
  bold       : 'Nunito-Bold', // 'Nunito-Black', // Nunito-ExtraBold
  extraBold  : 'Nunito-Black', // 'Nunito-Black',
  italicBold : 'Nunito-BoldItalic', // `Nunito-BoldItalic`,
  light      : 'Nunito-Regular', // 'Nunito-Regular',
  regular    : 'Nunito-Regular', // 'Nunito-Bold', // Nunito-SemiBold
  semiBold   : 'Nunito-SemiBold', // `Nunito-SemiBold`, // Nunito-Bold
  thin       : 'Nunito-Light', // `Nunito-Light`
}

const style = {
  h1: {
    fontFamily: type.base,
    fontSize: size.h1
  },
  h2: {
    fontWeight: 'bold',
    fontSize: size.h2
  },
  h3: {
    fontFamily: type.emphasis,
    fontSize: size.h3
  },
  h4: {
    fontFamily: type.base,
    fontSize: size.h4
  },
  h5: {
    fontFamily: type.base,
    fontSize: size.h5
  },
  h6: {
    fontFamily: type.emphasis,
    fontSize: size.h6
  },
  normal: {
    fontFamily: type.base,
    fontSize: size.regular
  },
  description: {
    fontFamily: type.base,
    fontSize: size.medium
  },
  navigation: {
    fontFamily: type.base,
    fontSize: size.medium
  },
  input: {
    fontFamily: type.base,
    fontSize: size.input
  },
  font,
  baseStyle: {
    fontFamily: font.regular, fontSize: 16, color: '#404861'
  },
  shadow: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.9,
    shadowRadius: 2,
    elevation: 1,
  },
  color: {
    background: '#FFFFFF',
    black: '#000000',
    danger: '#CE293D',
    dark: '#626A6C',
    disabled: '#d0d0d0',
    gradient: ['#5732B7', '#8754B9'],
    light: '#95A0A1',
    separator: '#F4F2EF',
    success: '#2BC05D',
    primary: '#8C00FF',
    white: '#ffffff',
    navbar: 'white',
    baseColor: '#000000', // '#404861',
    disable: '#c1c1c1',
    baseRed: 'rgba(182,28,40,1)',
    blur: 'rgb(40,179,240)',
    divider: '#E6E6E6',
    green: 'rgba(133,208,207,1)',
    progress: 'rgb(94,199,198)',
    swithColor :  `rgba(186,239,238,1)`,
    tagDonationColor :  `rgba(112,176,205,1)`,
    kargoePrice: 'rgba(102, 204, 204, 255)',
    transparentNavText: '#ffffff',
  },

}

export default {
  type,
  size,
  style
}
